import { render, staticRenderFns } from "./VuesticSimpleSelect.vue?vue&type=template&id=70860abd&"
import script from "./VuesticSimpleSelect.vue?vue&type=script&lang=js&"
export * from "./VuesticSimpleSelect.vue?vue&type=script&lang=js&"
import style0 from "./VuesticSimpleSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticSimpleSelect.vue"
export default component.exports